export default __webpack_public_path__ + "static/media/comistar.24e23f2a.jpeg";